import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonLoading = ({ MainLength = 5, length }) => {
  return [...Array(MainLength)].map((_, i) => {
    return (
      <tr className="text-center" key={i}>
        {[...Array(length)].map((_, i) => (
          <td className="text-nowrap" key={i}>
            <Skeleton />
          </td>
        ))}
      </tr>
    );
  });
};

export default SkeletonLoading;
